module.exports = __webpack_public_path__ + "static/media/leaderboard_preview.47967716.svg";